import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "../../core/translation.core";
import CombinedLogin from "./combinedLogin.comp";
import FacebookLogin from "./facebookLogin.comp";
import GoogleLogin from "./googleLogin.comp";
import MainLayout from "../layout/MainLayout";

export default function LoginForm() {
  const { t, msg } = useTranslation();
  const { query, pathname, push } = useRouter();

  const handleClick = () => {
    push({
      pathname: pathname,
      query: { ...query, page: "register" },
    });
  };

  return (
    <MainLayout title={t(msg.login.login)} url="/login">
      <div className="max-w-md mx-auto w-full py-10">
        <div className="bg-white px-6 py-8 mb-8 space-y-4 rounded-lg">
          <RegSuccessMsg />
          <CombinedLogin />
          <p className="grow-0 block font-serif text-xs md:text-sm">
            <Link className="text-primary underline cursor-pointer" href="/auth/forgetPwd" id="link-forgetPwd">
              {t(msg.account.forgetPassword)}
            </Link>
          </p>
          <GoogleLogin />
          {/* <FacebookLogin /> */}
        </div>
        <p className="grow-0 block py-2 font-serif text-sm md:text-base text-center">
          <span>{t(msg.login.actionRegister)}</span>
          <button id="register-link" onClick={handleClick} className="ml-2 text-primary underline cursor-pointer">
            {t(msg.login.register)}
          </button>
        </p>
      </div>
    </MainLayout>
  );
}

function RegSuccessMsg() {
  const { query, isReady } = useRouter();
  const { t, msg } = useTranslation();

  if (!isReady) return null;
  if ((query.regSuccess as string) !== "1") return null;

  return <p className="text-green-600">{t(msg.login.registerSuccess)}</p>;
}
